import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

export default class Cards {
    // GET /cards - The full card set and pack rules
    getCatalog() {
        return axios.get(`${API_BASE}/cards`).then(x => x.data);
    }

    // GET /cards/me - The logged-in user's collection ({ cardID: count }) and pack stock
    getMine() {
        return axios.get(`${API_BASE}/cards/me`, authHeaders()).then(x => x.data);
    }

    // POST /cards/open - Open a pack from a card set: returns the cards, which of them are new, and the pack stock afterwards
    openPack(setID) {
        return axios.post(`${API_BASE}/cards/open`, { set: setID }, authHeaders()).then(x => x.data);
    }

}
